import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import { withTranslation } from "react-i18next";

import HeaderCandidateJob from "components/Common/Header/Candidate/Job";
import Footer from "components/Common/Footer";

import PageWrapper from "hoc/PageWrapper";

import savedImg from "assets/images/candidate/saved.png";

import "./styles.scss";
import { copyToClipboard } from "mixins/helpers";
import Copy from "components/Tables/Jobs/Buttons/Copy";
import { CopyTable } from "mixins/svgIcons";

const SavedForLaterView = ({
  t,
  jobInfoCompany = {},
  candidateInfo: { invite_link: inviteLink }
}) => {
  const [copied, setCopied] = useState("");
  const [isHoveringIcon, setIsHoveringIcon] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const memorizedCompanyInfo = useMemo(() => jobInfoCompany, [jobInfoCompany]);

  const handleCopy = () => {
    setCopied(inviteLink);
    copyToClipboard(inviteLink);

    setTimeout(() => {
      setCopied("");
    }, 3000);
  };

  return (
    <PageWrapper
      header={<HeaderCandidateJob company={memorizedCompanyInfo} />}
      footer={(
        <Footer
          company={memorizedCompanyInfo}
          isPublic
        />
      )}
      overflowVisible
    >
      <Container>
        <Row bsPrefix="row candidate-start answers-saved__container">
          <Col md={{ span: 6, offset: 3 }}>
            <img src={savedImg} alt="chain" className="answers-saved__img" />
            <h1 className="answers-saved__title">
              {t("savedForLater.header")}
            </h1>
            <p className="answers-saved__text">{t("savedForLater.title")}</p>
            <p className="answers-saved__text">
              {t("savedForLater.description")}
            </p>
            {inviteLink && (
              <div
                className="w-full flex flex-row gap-2 justify-center items-center"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
              >
                <a
                  href={inviteLink}
                  className="answers-saved__text answers-saved__link mb-0"
                >
                  {inviteLink}
                </a>

                <Copy
                  handleCopy={handleCopy}
                  isCopied={copied === inviteLink}
                  isShowTooltip={copied === inviteLink}
                  copyBtn={<CopyTable
                    fill={isHoveringIcon ? "#5A2AF1" : "#B6BDC5"}
                    onMouseEnter={() => setIsHoveringIcon(true)}
                    onMouseLeave={() => setIsHoveringIcon(false)}
                    style={{ visibility: isHovering ? "visible" : "hidden" }}
                  />}
                />
              </div>
            )}
            <p className="answers-saved__text mt-4">{t("savedForLater.close")}</p>
          </Col>
        </Row>
      </Container>
    </PageWrapper>
  );
};

SavedForLaterView.propTypes = {
  t: PropTypes.func.isRequired,
  jobInfoCompany: PropTypes.shape({}).isRequired,
  candidateInfo: PropTypes.shape({
    invite_link: PropTypes.oneOfType([PropTypes.string])
  }).isRequired
};

export default withTranslation()(SavedForLaterView);
